export default __webpack_public_path__ + "static/2-b2c85f9b1df8bdca33fab3d3de2bb80c.png";